module.exports = __webpack_public_path__ + "img/contacttop.a4893093.png";